import React, {Component} from 'react';
import {withRouter} from 'react-router'
import PropTypes from 'prop-types';
import ContentLoader from "react-content-loader"
import {connect} from 'react-redux';
import * as actions from '../actions/index';
import {checkIfFollowingListAvailable} from "../util/follow_util"
import * as _ from 'lodash'
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import {getData, LOGIN} from "../util/storage";
import {checkIfUserIsOnBroadcasterSection, isEmpty, showModal} from "../util/utility";
import {checkBroadcasterAvialability} from "../util/broadcaster/profile_util";
import {decodeEncryptedIdForBroadcaster, getEncryptedIdForBroadcaster} from "../util/broadcast_util"
//image
import vuepay_blue from '../assets/images/icon-vuepay-blue@2x.png';
import onlineCircle from '../assets/images/icon-circle-blue@2x.png';
import {getUserProfile} from "../util/business_logic";
import {BroadcastFilterList} from "./LeftBar/index";
import MessageUser from "./MessageUser";
import Followers from "./Followers";

class LeftBar extends Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            wallet_balance: "0.00",
            followingList: [],
            followersList: [],
            favouritesList: [],
            liveNowCount: null,
            leftNavParentIndex: 0,
            commonmodalState: false,
            sort_by: "all",

            userDataForMessage: null,
            isVisible: false,
            messageAllData: null,
            isLoggedIn: false
        }
    }

    toggleCommonModal = () => {
        this.props.history.push(
            {
                pathname: '/login',
                state: { basePath: this.props.history.location.pathname }
            }
        );
    }

    componentDidMount() {
        getData(LOGIN)
            .then((data) => {

                this.setState({
                    isLoggedIn: !isEmpty(data)
                })

                if (!isEmpty(data)) {
                    this.props.getUserDetails(data.token, data.api_token);
                    if (!checkIfUserIsOnBroadcasterSection()) {
                        this.props.getFollowingList(data.token, data.api_token, "", "")
                    } else {
                        this.props.getFollowersList(data.token, data.api_token, "", "")
                        this.props.getFavouritesList(data.token, data.api_token, "", "")

                    }
                }
            })

            //update the state of the left bar when user refreshes the browser
        if (this.props.location.pathname.indexOf("dashboard") >= 0) {
            this.setState({ leftNavParentIndex: 0 });
        } else if (this.props.location.pathname.indexOf("following") >= 0) {
            this.setState({ leftNavParentIndex: 1 });
        } else if (this.props.location.pathname.indexOf("/broadcaster/create/broadcast") >= 0) {
            this.setState({ leftNavParentIndex: 2 });
        } else if (this.props.location.pathname.indexOf("/broadcaster/followers") >= 0) {
            this.setState({ leftNavParentIndex: 3 });
        } else if (this.props.location.pathname.indexOf("/broadcaster/favourites") >= 0) {
            this.setState({ leftNavParentIndex: 4 });
        } else if (this.props.location.pathname.indexOf("/broadcaster/create/availability") >= 0) {
            this.setState({ leftNavParentIndex: 5 });
        } else if (this.props.location.pathname.indexOf("/broadcaster/my-library") >= 0) {
            this.setState({ leftNavParentIndex: 6 });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (
            nextProps.hasOwnProperty("broadcaster_send_message") &&
            nextProps.broadcaster_send_message.hasOwnProperty("messageModal") &&
            nextProps.broadcaster_send_message.messageModal !== null &&
            nextProps.broadcaster_send_message.messageModal !== undefined
        ) {
            const data = nextProps.broadcaster_send_message.messageModal;
            // this.setState({data});
            this.setState({
                isVisible: true,
                userDataForMessage:
                nextProps.broadcaster_send_message.messageModal.userData,
                messageAllData:
                nextProps.broadcaster_send_message.messageModal.messageAllData,
            });
            this.props.hideMessageModal();
        }

        if (checkIfFollowingListAvailable(nextProps)) {
            this.setState({
                followingList: nextProps.following.followingList.data.data
            });
        }

        if (this.props.moneyblox.wallet_balance !== nextProps.moneyblox.wallet_balance) {
            this.setState({
                wallet_balance: nextProps.moneyblox.wallet_balance
            })
        }

        if (nextProps.hasOwnProperty("broadcaster_followers") &&
            nextProps.broadcaster_followers.hasOwnProperty("followersList") &&
            nextProps.broadcaster_followers.followersList &&
            nextProps.broadcaster_followers.followersList !== null &&
            nextProps.broadcaster_followers.followersList.data.hasOwnProperty("data") &&
            nextProps.broadcaster_followers.followersList.data.data !== null) {
            this.setState({
                followersList: nextProps.broadcaster_followers.followersList.data.data
            })

        }

        if (nextProps.hasOwnProperty("broadcaster_favourites") &&
            nextProps.broadcaster_favourites.hasOwnProperty("favouritesList") &&
            nextProps.broadcaster_favourites.favouritesList &&
            nextProps.broadcaster_favourites.favouritesList !== null &&
            nextProps.broadcaster_favourites.favouritesList.data.hasOwnProperty("data") &&
            nextProps.broadcaster_favourites.favouritesList.data.data !== null) {

            this.setState({
                favouritesList: nextProps.broadcaster_favourites.favouritesList.data.data
            })
            //this.props.resetFavouritesList();
        }

        if (nextProps.get_content_list.payload &&
            nextProps.get_content_list.payload.hasOwnProperty("data") &&
            nextProps.get_content_list.payload.data.hasOwnProperty("data") && window.location.pathname.includes("dashboard")) {

            let data = nextProps.get_content_list.payload.data;
            this.setState({
                liveNowCount: data.total
            })

        }

        // if (nextProps.broadcaster_detail_management && nextProps.broadcaster_detail_management.trendingBroadcasters &&
        //     nextProps.broadcaster_detail_management.trendingBroadcasters.data) {
        //     this.setState({
        //         liveNowCount: nextProps.broadcaster_detail_management.trendingBroadcasters.data.total
        //     })
        // }

        //MoneyBlox
        if (nextProps.moneyblox.hasOwnProperty("wallet_balance") &&
            nextProps.moneyblox.hasOwnProperty("user_details") &&
            nextProps.moneyblox.user_details !== null) {
            this.setState({
                wallet_balance: this.props.moneyblox.wallet_balance
            })
        }
    }

    showBroadcasterDetailModal = () => {
        const modal = document.getElementById("availability-description");
        showModal(modal)
    }

    openAvailabilityPopup = ()=>{
        this.props.history.push("/broadcaster/availability")
        setTimeout(()=>{
            this.showBroadcasterDetailModal()
        },500);
    }
    //update the state of the left bar when user clicks on the menu
    toggleLeftNavParent = (index)=> {
        this.setState({leftNavParentIndex: index, sort_by: "all"}, () => {
            const searchInput = document.getElementsByName('searchInput')[0]
            if (searchInput) {
                searchInput.value = ''
            }
            if (index === 0) {
                this.props.history.push("/dashboard");
            } else if (index === 1) {
                this.props.history.push("/following");
            } else if (index === 2) {
                this.props.history.push("/broadcaster/create/broadcast");
            } else if (index === 3) {
                this.props.history.push("/broadcaster/followers");
            } else if (index === 4) {
                this.props.history.push("/broadcaster/favourites");
            } else if (index === 5) {
                checkBroadcasterAvialability(this.props.account_management.userDetails) ? this.openAvailabilityPopup() : this.props.history.push("/broadcaster/create/availability");
            } else if (index === 6) {
                this.props.history.push("/broadcaster/my-library");
            }else if (index === 7) {
                this.props.history.push("/broadcaster/messaging");
            }

        })
    }

    //update the state of the left bar when user clicks on the menu of Broadcaster
    toggleLeftNavParentOfBroadcaster(index) {
        this.setState({ leftNavParentIndex: index }, () => {
            const searchInput = document.getElementsByName('searchInput')[0]
            if (searchInput) {
                searchInput.value = ''
            }
            if (index === 0) {
                this.props.history.push("/broadcaster/create/broadcast");
            } else if (index === 1) {
                this.props.history.push("/following");
            }
        })
    }

    // Listener for click event of trending sort
    clickedOnSortByFilter = (sort_by,setSortByState = true) => (e) => {

        if (this.props.account_management.userDetails !== null) {
            this.props.history.push("/dashboard");
            this.props.sortBroadcastBy(sort_by);
            if (setSortByState) {
                this.setState({
                    sort_by
                });
            } else {
                this.toggleLeftNavParent(0);
                this.setState({
                    sort_by: "all"
                });
            }
        } else {
            this.toggleCommonModal();
        }

    }

    clickedOnMessageAllToFollowers = () => {
        const data = {
            isVisible: true,
            messageAllData: "followers",
            userData: null
        }
        this.props.showMessageModal(data)
    }

    clickedOnMessageAllToFavourites = () => {
        const data = {
            isVisible: true,
            messageAllData: "favourites",
            userData: null
        }
        this.props.showMessageModal(data)
    }

    clickedOnIndividualUserForMessage = (userData) => () => {
        // const data = {
        //     isVisible: true,
        //     messageAllData: null,
        //     userData: userData
        // }
        // this.props.showMessageModal(data)
        console.log("clickedOnIndividualUserForMessage >> userData",userData)
        const user_id_encrypted = getEncryptedIdForBroadcaster(userData.user_id);
        this.props.history.push(`/broadcaster/user/profile/${user_id_encrypted}`)
    }

    toggleVisibilityOfMessage = () => {
        this.setState({isVisible: !this.state.isVisible});
    };

    render() {
        let followingLeftNavParent = classNames({ 'highlight': true, 'active': this.state.leftNavParentIndex === 1 }),
            goLiveLeftNavParent = classNames({ 'highlight': true, 'active': this.state.leftNavParentIndex === 2 }),
            followersLeftNavParent = classNames({ 'highlight': true, 'active': this.state.leftNavParentIndex === 3 }),
            favouritesLeftNavParent = classNames({ 'highlight': true, 'active': this.state.leftNavParentIndex === 4 }),
            availabilityLeftNavParent = classNames({ 'highlight': true, 'active': this.state.leftNavParentIndex === 5 }),
            myLibraryLeftNavParent = classNames({ 'highlight': true, 'active': this.state.leftNavParentIndex === 6 }),
        chatLeftNavParent = classNames({ 'highlight': true, 'active': this.state.leftNavParentIndex === 7 });

        return (
            <div>
                {
                    this.props.account_management.userDetails !== null ?
                        <div className="leftNav" id="leftNav">
                            {
                                !checkIfUserIsOnBroadcasterSection() &&
                                <BroadcastFilterList
                                    get_content_list={this.props.get_content_list}
                                    leftNavParentIndex={this.state.leftNavParentIndex}
                                    sort_by={this.state.sort_by}
                                    liveNowCount={this.state.liveNowCount}
                                    clickedOnSortByFilter={this.clickedOnSortByFilter}/>
                            }

                            {
                                !checkIfUserIsOnBroadcasterSection() &&
                                <ul className="left-nav">
                                    <li className="highlight">
                                        <Link to={'/viewer/messaging'}>
                                            <div className="left chats">Messaging</div>
                                        </Link>
                                    </li>
                                </ul>
                            }

                            {!checkIfUserIsOnBroadcasterSection() && <ul className="left-nav">
                                <li className={followingLeftNavParent} id="leftNavFollowing">
                                    <a href="javascript:void(0);" onClick={() => {
                                        this.toggleLeftNavParent(1)
                                    }}>
                                        <div className="left following"> Following
                                        </div>
                                        {this.state.followingList.length > 0 &&
                                            <div className="right">{this.state.followingList.length}</div>
                                        }
                                    </a>
                                </li>


                                {
                                    (this.props.following.isFetching && this.state.followingList.length === 0)
                                        ?
                                        <ContentLoader
                                            height={240}
                                            speed={1}
                                            primaryColor="#f3f3f3"
                                            secondaryColor="#ecebeb"
                                        >
                                            <rect x="72" y="20" rx="4" ry="4" width="200" height="20" />
                                            <rect x="72" y="80" rx="4" ry="4" width="200" height="20" />
                                            <rect x="72" y="140" rx="4" ry="4" width="200" height="20" />
                                            <rect x="72" y="200" rx="4" ry="4" width="200" height="20" />
                                            <circle cx="36" cy="30" r="22" />
                                            <circle cx="36" cy="90" r="22" />
                                            <circle cx="36" cy="150" r="22" />
                                            <circle cx="36" cy="210" r="22" />
                                        </ContentLoader>
                                        :
                                        this.state.followingList.length > 0 && _.map(this.state.followingList, (data) => {
                                            return <li key={data.id}
                                                id={data.id}
                                                data-name={data.username}>

                                                <Link to={'/profile/' + getEncryptedIdForBroadcaster(data.id)}>
                                                    <div className="left" id="datatest">
                                                        <span className="followers"><img width={"100%"}
                                                            src={data.profile_pic}
                                                            alt="Follower" /></span> {data.username}
                                                    </div>
                                                    {data.status === "online" && <div className="right">
                                                        <img src={vuepay_blue} alt="visible" />
                                                    </div>}
                                                </Link>
                                            </li>;
                                        })
                                }

                            </ul>}

                            {checkIfUserIsOnBroadcasterSection() && <ul className="left-nav">
                                <li className={goLiveLeftNavParent} id="leftNavGoLive">
                                    <a href="javascript:void(0);" onClick={() => {
                                        this.toggleLeftNavParent(2)
                                    }}>
                                        <div className="left live">Broadcast a Video</div>
                                    </a>
                                </li>
                                <li className={availabilityLeftNavParent} id="leftNavAvailability">
                                    <a href="javascript:void(0);" onClick={() => {
                                        this.toggleLeftNavParent(5)
                                    }}>
                                        <div className="left availablility">{checkBroadcasterAvialability(this.props.account_management.userDetails) ? "You're Available" : "Say Available"}</div>
                                    </a>
                                </li>
                                <li className={myLibraryLeftNavParent} id="leftNavMyLibrary">
                                    <a href="javascript:void(0);" onClick={() => {
                                        this.toggleLeftNavParent(6)
                                    }}>
                                        <div className="left my-library">My Library</div>
                                    </a>
                                </li>
                                <li className={chatLeftNavParent} id="leftNavChats">
                                    <a href="javascript:void(0);" onClick={() => {
                                        this.toggleLeftNavParent(7)
                                    }}>
                                        <div className="left chats">Messaging</div>
                                    </a>
                                </li>
                            </ul>}


                            <Followers
                                followersLeftNavParent={followersLeftNavParent}
                                toggleLeftNavParent={this.toggleLeftNavParent}
                                followersList={this.state.followersList}
                                broadcaster_followers={this.props.broadcaster_followers}
                                clickedOnMessageAllToFollowers={this.clickedOnMessageAllToFollowers}
                                clickedOnIndividualUserForMessage={this.clickedOnIndividualUserForMessage}/>

                            {checkIfUserIsOnBroadcasterSection() && <ul className="left-nav">
                                <li className={favouritesLeftNavParent} id="leftNavFavourites">
                                    <a href="javascript:void(0);" onClick={() => {
                                        this.toggleLeftNavParent(4)
                                    }}>
                                        <div className="left favourites">Favourites</div>
                                        {this.state.favouritesList.length > 0 &&
                                        <div className="right">{this.state.favouritesList.length}</div>}
                                    </a>
                                </li>
                                {this.state.favouritesList.length > 0 && <li className="active">
                                    <a href="javascript:void(0);" className="font-weight-normal"
                                       onClick={this.clickedOnMessageAllToFavourites}>Announcement</a>
                                </li>}
                                {
                                    (this.props.broadcaster_favourites.isFetching && this.state.favouritesList.length === 0)
                                        ?
                                        <ContentLoader
                                            height={240}
                                            speed={1}
                                            primaryColor="#f3f3f3"
                                            secondaryColor="#ecebeb"
                                        >
                                            <rect x="72" y="20" rx="4" ry="4" width="200" height="20"/>
                                            <rect x="72" y="80" rx="4" ry="4" width="200" height="20"/>
                                            <rect x="72" y="140" rx="4" ry="4" width="200" height="20"/>
                                            <rect x="72" y="200" rx="4" ry="4" width="200" height="20"/>
                                            <circle cx="36" cy="30" r="22"/>
                                            <circle cx="36" cy="90" r="22"/>
                                            <circle cx="36" cy="150" r="22"/>
                                            <circle cx="36" cy="210" r="22"/>
                                        </ContentLoader>
                                        :
                                        this.state.favouritesList.length > 0 && _.map(this.state.favouritesList, (data) => {
                                            return <li key={data.user_id}
                                                       onClick={this.clickedOnIndividualUserForMessage(data)}>
                                                <a href="javascript:void(0);">
                                                    <div className="left"><span className="followers">
                                                        <img width={"100%"} src={getUserProfile(data.profile_pic)}
                                                             alt="Follower"/></span> {data.username}
                                                    </div>
                                                    {data.status === "online" && <div className="right">
                                                        <img src={onlineCircle} alt="visible"/>
                                                    </div>}
                                                </a>
                                            </li>
                                        })
                                }
                            </ul>}

                            {
                                !checkIfUserIsOnBroadcasterSection() &&
                                <ul className="left-nav">
                                    <li className="highlight">
                                        <a href="#" onClick={() => {
                                            this.props.showMoneyBloxModal()
                                        }}>
                                            <div className="left credit">Credit</div>

                                            {
                                                this.state.wallet_balance === "Login"
                                                    ?
                                                    <div className="right">Login</div>
                                                    :
                                                    <div className="right">£{this.state.wallet_balance}</div>
                                            }

                                        </a>
                                    </li>
                                </ul>
                            }
                        </div>
                        :
                        <div className="leftNav" id="leftNav">

                            <BroadcastFilterList
                                get_content_list={this.props.get_content_list}
                                leftNavParentIndex={this.state.leftNavParentIndex}
                                sort_by={this.state.sort_by}
                                liveNowCount={this.state.liveNowCount}
                                clickedOnSortByFilter={this.clickedOnSortByFilter}/>

                            <ul className="left-nav sign-in-div">
                                <li className="highlight" style={{ padding: 0 }}>
                                    <div className="sign-in-description">Sign in to follow, view broadcast and chat with
                                    the broadcaster.
                                    </div>
                                    <div className="vertical-center" style={{ marginTop: -34 }}>
                                        <button className="signin-button-sidebar" onClick={this.toggleCommonModal}>SIGN
                                        IN
                                        </button>
                                    </div>
                                </li>
                            </ul>

                        </div>
                }

                <MessageUser
                    isVisible={this.state.isVisible}
                    userData={this.state.userDataForMessage}
                    messageAllData={this.state.messageAllData}
                    closeMessage={this.toggleVisibilityOfMessage}
                />
            </div>
        );
    }
}

LeftBar = withRouter(LeftBar);

// export default LeftBar;
function mapStateToProps(state) {
    return {
        get_content_list: state.get_content_list,
        account_management: state.account_management,
        following: state.following,
        broadcaster_detail_management: state.broadcaster_detail_management,
        broadcaster_followers: state.broadcaster_followers,
        broadcaster_favourites: state.broadcaster_favourites,
        broadcaster_send_message: state.broadcaster_send_message,
        moneyblox: state.moneyblox,

    };
}

export default connect(mapStateToProps, actions)(LeftBar);